import Signal from "badmfck-signal";

const AUTH_STEPS = ["login", "otp", "forgot", "changePassword", "reg1", "reg2", "reg3", "reg4", "regOk"] as const;
const DEFAULT_AUTH_STEP = "login";
const RESTORE_ROUTE = "restore/";
const INVITE_ROUTE = "invite/";

export type TAuthSteps = (typeof AUTH_STEPS)[number];

export const S_AUTH_CHANGE_VIEW = new Signal<TAuthSteps>("", cb => {
	cb!(DEFAULT_AUTH_STEP);
});

export const S_REGISTRATION_COMPLETE = new Signal<{
	login: string;
	pass: string;
}>("S_REGISTRATION_COMPLETE");

export { DEFAULT_AUTH_STEP, INVITE_ROUTE, RESTORE_ROUTE };
